import type { TFunction } from 'react-i18next';

import type { TStationIds } from '@/types/station';

export const extractIds = ({ merchantId, storeId }: TStationIds, t: TFunction) =>
  [
    merchantId && `${t('station.merchantId')} ${merchantId}`,
    storeId && `${t('station.storeId')} ${storeId}`,
  ]
    .filter(Boolean)
    .join(' • ');
